const EUR = new Intl.NumberFormat("de-DE", {
  style: "currency",
  currency: "EUR",
});

const DATE = new Intl.DateTimeFormat("de-DE", {
  day: "2-digit",
  month: "2-digit",
  year: "numeric",
});

const DATETIME = new Intl.DateTimeFormat("de-DE", {
  day: "2-digit",
  month: "2-digit",
  year: "numeric",
  hour: "2-digit",
  minute: "2-digit",
});

const MONTH_LONG = new Intl.DateTimeFormat("de-DE", {
  month: "long",
});

export function formatCurrency(amount: number | null | undefined, currency = "EUR"): string {
  if (amount === null || amount === undefined) return "—";
  if (currency === "EUR") return EUR.format(amount);
  return `${amount.toFixed(2)} ${currency}`;
}

export function formatDate(iso: string | null | undefined): string {
  if (!iso) return "—";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "—";
  return DATE.format(d);
}

export function formatDateTime(iso: string | null | undefined): string {
  if (!iso) return "—";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "—";
  return DATETIME.format(d);
}

export function monthName(monthNumber: number): string {
  return MONTH_LONG.format(new Date(2000, monthNumber - 1, 1));
}

export function formatQuantity(q: number | null | undefined, unit: string | null | undefined): string {
  if (q === null || q === undefined) return "—";
  const formatted = Number.isInteger(q) ? q.toFixed(0) : q.toFixed(3).replace(/\.?0+$/, "");
  return unit ? `${formatted} ${unit}` : formatted;
}

export const USAGE_TYPE_LABEL: Record<string, string> = {
  private: "Privat",
  business: "Geschäftlich",
  rental: "Vermietung",
  income_tax_other: "Sonstige Werbungskosten",
  private_sale: "Privatverkauf",
};

// Migration 0014 (2026-06-05 spät): Zahlungsart pro Beleg. Reihenfolge spiegelt Häufigkeit
// (cash + Karten oben, dann digital, dann Rechnungs-/Sonderpfade unten).
export const PAYMENT_METHOD_LABEL: Record<string, string> = {
  cash: "Bar",
  girocard: "Girocard / EC",
  visa: "Visa",
  mastercard: "Mastercard",
  amex: "American Express",
  paypal: "PayPal",
  apple_pay: "Apple Pay",
  google_pay: "Google Pay",
  bank_transfer: "Überweisung",
  direct_debit: "Lastschrift",
  invoice_open: "Rechnung offen",
  gift_card: "Geschenkkarte",
  other: "Sonstiges",
};
export const PAYMENT_METHODS_ORDER = [
  "cash", "girocard", "visa", "mastercard", "amex",
  "paypal", "apple_pay", "google_pay",
  "bank_transfer", "direct_debit",
  "invoice_open", "gift_card", "other",
] as const;
